<template>
    <div class="page">
        <ion-grid fixed v-if="displayInd">
            <ion-row class="row-divider"></ion-row>
            <ion-row class="rectangle">
                <ion-col>
                    <ion-row align-items-stretch>
                        <ion-col class="col-padding">
                            <ion-label class="section-head">Tariff Header</ion-label>
                        </ion-col>
                    </ion-row>
                    <ion-row align-items-stretch v-if="displayInd">
                        
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">Tariff Code</ion-label>
                            <div class="section-desc margin-top-10 select-cahrger-station">{{ tariff.tariffCode }}</div>
                        </ion-col>
                        <!-- <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">Tariff Description</ion-label>
                            <div class="section-desc margin-top-10 select-cahrger-station">{{ tariff.description }}</div>
                        </ion-col> -->
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">Effective From</ion-label>
                            <div class="section-desc margin-top-10 select-cahrger-station">{{ changeDateFormatWithoutTime(tariff.effectiveFrom) }}</div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">Effective To</ion-label>
                            <div class="section-desc margin-top-10 select-cahrger-station">{{ changeDateFormatWithoutTime(tariff.effectiveTo) }}</div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">Time Of Unit</ion-label>
                            <div class="section-desc margin-top-10 select-cahrger-station">{{ tariff.isToUTariff.description }}</div>
                        </ion-col> 
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">Zero Tariff</ion-label>
                            <div class="section-desc margin-top-10 select-cahrger-station">{{ tariff.zeroTariff.description }}</div>
                        </ion-col> 
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">Status</ion-label>
                            <div class="section-desc margin-top-10 select-cahrger-station">{{ getStatus(tariff.status) }}</div>
                        </ion-col> 
                    </ion-row>
                    <ion-row>
                        <ion-col class="col-padding">
                            <ion-label class="section-head">Tariff Details</ion-label>
                        </ion-col>
                    </ion-row>
                    
                    <div v-for="(value, index) in tariff.tariffDetails" :key="index">
                        <ion-row>
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">Tariff Rate</ion-label>
                            <div class="section-desc margin-top-10 select-cahrger-station">{{ value.rate }}</div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">Time Of Day</ion-label>
                            <div class="section-desc margin-top-10 select-cahrger-station">{{ value.timeOfDay.description }}</div>
                        </ion-col>
                        <!-- <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">Description</ion-label>
                            <div class="section-desc margin-top-10 select-cahrger-station">{{ value.description }}</div>
                        </ion-col> -->
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">Unit Of Measure</ion-label>
                            <div class="section-desc margin-top-10 select-cahrger-station">{{ value.unitOfMeasure }}</div>
                        </ion-col>
                        </ion-row>
                        
                        <div>
                            
                            <ion-row >
                                <ion-col size="12" size-md="3">
                                    <ion-label class="section-item" position="stacked">Tax</ion-label>
                                    <div class="section-desc margin-top-10 select-cahrger-station">{{ value.taxPercentage }}</div>
                                </ion-col> 
                                <ion-col size="12" size-md="3">
                                    <ion-label class="section-item" position="stacked">CGST</ion-label>
                                    <div class="section-desc margin-top-10 select-cahrger-station">{{ value.CGSTPercentage }}</div>
                                </ion-col>
                                <ion-col size="12" size-md="3">
                                    <ion-label class="section-item" position="stacked">SGST</ion-label>
                                    <div class="section-desc margin-top-10 select-cahrger-station">{{ value.SGSTPercentage }}</div>
                                </ion-col>
                            </ion-row><br>
                            <ion-row v-for="timeVal in value.timeDetails" :key="timeVal">
                                <!-- <ion-col size="12" size-md="3">
                                    <ion-label class="section-item" position="stacked">season</ion-label>
                                    <div class="section-desc margin-top-10 select-cahrger-station">{{ value.season }}</div>
                                </ion-col> -->
                                <!-- <div v-for="timeVal in value.timeDetails"> -->
                                    <ion-col size="12" size-md="3" >
                                        <ion-label class="section-item" position="stacked">From Time</ion-label>
                                        <div class="section-desc margin-top-10 select-cahrger-station">{{ timeVal.fromTime }}</div>
                                    </ion-col>
                                    <ion-col size="12" size-md="3">
                                        <ion-label class="section-item" position="stacked" >To Time</ion-label>
                                        <div class="section-desc margin-top-10 select-cahrger-station">{{ timeVal.toTime }}</div>
                                    </ion-col>
                                    <ion-col size="12" size-md="3">
                                        <ion-label class="section-item" position="stacked" >Effective From</ion-label>
                                        <div class="section-desc margin-top-10 select-cahrger-station">{{ changeDateFormatWithoutTime(timeVal.effectiveFrom) }}</div>
                                    </ion-col>
                                    <ion-col size="12" size-md="3">
                                        <ion-label class="section-item" position="stacked" >Effective To</ion-label>
                                        <div class="section-desc margin-top-10 select-cahrger-station">{{ changeDateFormatWithoutTime(timeVal.effectiveTo) }}</div>
                                    </ion-col>
                                <!-- </div> -->
                                
                            </ion-row>
                            <br>
                        <hr class="line-style" />
                        <br>
                        </div>
                    </div>
                    
                </ion-col>
            </ion-row>
        </ion-grid>
        <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
    </div>
</template>


<script>
import { defineComponent } from "vue";
import { IonButton, IonCol, IonGrid, IonLabel, IonRow, IonInput, IonSelect, IonSelectOption, IonFabButton } from "@ionic/vue";
import datepicker from 'vue3-datepicker';
import { ToastUtils } from "../../util/toast-utils";
import { AdminService } from "@/service/admin/admin.service";
import { migratedTryParseServiceError } from "../../service";
import { add, trash, timeOutline } from 'ionicons/icons';
import moment from "moment";

export default defineComponent({
    name: 'TariffDetails',
    components:{
        IonGrid, IonRow, IonCol, IonButton, IonLabel, IonInput, datepicker, IonSelect, IonSelectOption, IonFabButton
    },
    

    data(){
        return{
            add, 
            tariff: {},
            displayInd: false
        }
    },
    mounted() {
        this.tariff = JSON.parse(localStorage.getItem('tariffList'));
        if(this.tariff != null) {
            this.displayInd = true;
        }
        
    },
    methods: {
        changeDateFormatWithoutTime(dateValue) {
            if(dateValue != null) {
                return moment(dateValue).format('DD/MMM/YYYY');
            }
        },

        changeDateFormat(dateValue) {
            return moment(dateValue).format('HH:mm')
        },
        getStatus(status) {
            return status.description
        }
    }
})
</script>

<style scoped>
.section-head {
    font-size: 15px;
    font-weight: bold;
}
.line-style {
    border-top: 1px solid #041648 !important;
  margin: 0px;
  opacity: 1;
}

.section-item {
    font-size: 14px;
}
</style>